// DataContext.js
import React, { createContext, useState, useEffect } from 'react';
import data from '../data.json';

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [appData, setAppData] = useState(null);

  useEffect(() => {
    // Check if there's updated data in localStorage (from CMS)
    const savedData = localStorage.getItem('websiteData');
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        setAppData(parsedData);
      } catch (error) {
        console.error('Error parsing saved data:', error);
        setAppData(data);
      }
    } else {
      // Use default data
      setAppData(data);
    }
  }, []);

  return (
    <DataContext.Provider value={appData}>
      {children}
    </DataContext.Provider>
  );
};
